/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getArrayDecoder,
  getArrayEncoder,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
  type Option,
  type OptionOrNullable,
} from "@solana/kit";

/** Proposal metadata */
export type ProposalMetadata = {
  /** IPFS hash for detailed proposal */
  ipfsHash: Option<string>;
  /** External references */
  externalReferences: Array<string>;
  /** Proposal tags */
  tags: Array<string>;
  /** Risk assessment */
  riskAssessment: Option<string>;
  /** Impact analysis */
  impactAnalysis: Option<string>;
  /** Implementation timeline */
  implementationTimeline: Option<string>;
};

export type ProposalMetadataArgs = {
  /** IPFS hash for detailed proposal */
  ipfsHash: OptionOrNullable<string>;
  /** External references */
  externalReferences: Array<string>;
  /** Proposal tags */
  tags: Array<string>;
  /** Risk assessment */
  riskAssessment: OptionOrNullable<string>;
  /** Impact analysis */
  impactAnalysis: OptionOrNullable<string>;
  /** Implementation timeline */
  implementationTimeline: OptionOrNullable<string>;
};

export function getProposalMetadataEncoder(): Encoder<ProposalMetadataArgs> {
  return getStructEncoder([
    [
      "ipfsHash",
      getOptionEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "externalReferences",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "tags",
      getArrayEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "riskAssessment",
      getOptionEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "impactAnalysis",
      getOptionEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
    [
      "implementationTimeline",
      getOptionEncoder(addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())),
    ],
  ]);
}

export function getProposalMetadataDecoder(): Decoder<ProposalMetadata> {
  return getStructDecoder([
    [
      "ipfsHash",
      getOptionDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "externalReferences",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "tags",
      getArrayDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "riskAssessment",
      getOptionDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "impactAnalysis",
      getOptionDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
    [
      "implementationTimeline",
      getOptionDecoder(addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())),
    ],
  ]);
}

export function getProposalMetadataCodec(): Codec<
  ProposalMetadataArgs,
  ProposalMetadata
> {
  return combineCodec(
    getProposalMetadataEncoder(),
    getProposalMetadataDecoder(),
  );
}
